import { Box, TypographyProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { routes } from "../../../app/paths";
import NewTabLinkButton from "../../../common/components/functional/links/NewTabLinkButton";
import OverlaySpinner from "../../../common/components/functional/overlaySpinner/OverlaySpinner";
import { useCustomerNavigation } from "../../../hooks/useCustomerNavigation";
import { EditEntry, Entry } from "../entriesAPI";

type Props = {
  entry: EditEntry | Entry;
  talentName?: string;
  talentId?: string;
};

const EntryLinks = ({ entry, talentName, talentId }: Props) => {
  const { t } = useTranslation("hourEntries");
  const { navigateToCustomer, isNavigationLoading } = useCustomerNavigation();

  const secondaryTypographyProps: TypographyProps = {
    variant: "secondary",
    fontSize: "17px",
  };

  const notFoundTypographyProps = {
    TypographyProps: secondaryTypographyProps,
  } as const;

  return (
    <>
      <OverlaySpinner isLoading={isNavigationLoading} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box display="flex" alignItems="center" flexWrap="wrap" gap="16px">
          {talentName && talentId && (
            <NewTabLinkButton
              text={talentName}
              to={routes.talentProfile(talentId)}
              buttonSx={{
                fontSize: "22px",
                marginRight: "16px",
                marginBottom: "2px",
                maxWidth: "300px",
                minWidth: 0,
              }}
              TypographyProps={{
                sx: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              }}
            />
          )}
          <NewTabLinkButton
            onClick={() => navigateToCustomer(entry.customerOrgId)}
            text={entry.customerOrgName}
            buttonSx={{
              fontSize: "17px",
              maxWidth: "300px",
            }}
            TypographyProps={{
              sx: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }}
          />
          <NewTabLinkButton
            to={
              entry?.assignmentId
                ? routes.talentAssignment(entry.talentId, entry.assignmentId)
                : ""
            }
            text={entry?.assignmentId ? t("showAssignment") : t("noAssignment")}
            buttonSx={{ fontSize: "17px" }}
            {...(!entry?.assignmentId && notFoundTypographyProps)}
          />
          <NewTabLinkButton
            to={entry?.bundleId ? routes.orderEdit(entry.bundleId) : ""}
            text={entry?.bundleId ? t("showOrder") : t("noOrder")}
            buttonSx={{ fontSize: "17px" }}
            {...(!entry?.bundleId && notFoundTypographyProps)}
          />
        </Box>
      </Box>
    </>
  );
};

export default EntryLinks;
